const templateVariantSettings = {
  header: "COMPRESSED",
  homePage: "HomeTemplateV9",
  websiteName: "Fieldstone CU",
  speedBump: {
    borderWithRadious: true,
  },
  about: null,
  contact: null,
  footer: null,
};

module.exports = templateVariantSettings;
